import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#00549A",
        },
    },
    typography: {
        button: {
            textTransform: "none",
        },
    },
    overrides: {
        // Style sheet name ⚛️
        MuiButton: {
            // Name of the rule
            text: {
                // Some CSS
                color: "var(--blue-bell)",

                fontFamily: "Arial",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "16px",
            },
        },
        MuiOutlinedInput: {
            input: {
                padding: "8px 8px",
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: "none",
                padding: "4px 8px",
                "&:first-child": {
                    padding: "4px 8px 4px 0px",
                },
            },
        },
        MuiPickersPopper: {
            root: {
                marginTop: "4rem",
            },
        },
        MuiTabs: {
            indicator: {
                height: "4px",
                background: "var(--blue-bell)",
            },
        },

        MuiTab: {
            textColorInherit: {
                color: "var(--inactive-color)",
                opacity: "unset",
                "&$selected": {
                    color: "var(--text-dark)",
                    fontWeight: "700",
                },
            },
        },
    },
});

export default theme;
